import { CSSProperties } from 'react'
import { StyleModifier } from 'components/styles/primitives/modifiers/types'
import { css } from '@emotion/react'
import { space } from '../size/space'

type PaddingValue = CSSProperties['paddingTop']
interface PaddingModProps {
	top?: PaddingValue
	bottom?: PaddingValue
	left?: PaddingValue
	right?: PaddingValue
}

export const PaddingMod: StyleModifier<PaddingModProps> = ({ top, left, bottom, right }) =>
	css({ paddingTop: top, paddingLeft: left, paddingBottom: bottom, paddingRight: right })

export const PaddingMods = {
	Sides: (amount: PaddingValue) => PaddingMod({ left: amount, right: amount }),
	Ends: (amount: PaddingValue) => PaddingMod({ top: amount, bottom: amount }),
	All: (amount: PaddingValue) => css({ padding: amount }),
	None: css({ padding: '0px' }),
	Base: css({ padding: space({}) }),
	...PaddingMod
}
